/**
 * Two corner-gutter stripe fills + rail lines on their inner edges.
 *
 * Gutter = space between viewport edge and the content column.
 * Width formula: max(12px, calc(50% - 36rem))
 *   - 36rem = 576px → at 1440px viewport: 720 - 576 = 144px gutter
 *   - at < 1152px viewport: falls back to 12px minimum
 *
 * The gutter sits at z-20 so its stripe fill shows on top of section
 * backgrounds inside the gutter area. Content lives at z-10 between the
 * rails and is never visually overlapped.
 */

const GUTTER_W = '48px';

const STRIPE_BG =
  'repeating-linear-gradient(135deg, transparent, transparent 8px, rgba(0,0,0,0.045) 8px, rgba(0,0,0,0.045) 10px)';

export function SideRails() {
  return (
    <div className="pointer-events-none absolute inset-0 z-20 hidden overflow-hidden md:block" aria-hidden>
      {/* ── Left gutter stripe fill ── */}
      <div
        className="absolute inset-y-0 left-0"
        style={{ width: GUTTER_W, backgroundImage: STRIPE_BG }}
      />
      {/* ── Left rail line (inner edge of left gutter) ── */}
      <div
        className="absolute inset-y-0 w-px bg-gray-200/70"
        style={{ left: GUTTER_W }}
      />

      {/* ── Right gutter stripe fill ── */}
      <div
        className="absolute inset-y-0 right-0"
        style={{ width: GUTTER_W, backgroundImage: STRIPE_BG }}
      />
      {/* ── Right rail line (inner edge of right gutter) ── */}
      <div
        className="absolute inset-y-0 w-px bg-gray-200/70"
        style={{ right: GUTTER_W }}
      />
    </div>
  );
}
